/**
 * Eye symbol with diagonal slash — "hide overlay" indicator.
 * Uses `currentColor`.
 */
export function HideOverlay({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 39 32"
      fill="none"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <path
        d="M34.3534 1.61743L5.43296 30.5378"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19.3761 4.8147C11.5679 4.8147 4.03863 12.251 1.25 15.9692C4.03863 19.6874 11.5679 27.1237 19.3761 27.1237C27.1843 27.1237 34.7136 19.6874 37.5022 15.9692C34.7136 12.251 27.1843 4.8147 19.3761 4.8147Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle
        cx="19.3761"
        cy="15.9691"
        r="5.97158"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  )
}
